import {RouterModule, Routes} from "@angular/router";
import {AdminLayoutComponent} from "../../shared/components/layout/admin-layout/admin-layout.component";
import {ErrorComponent} from "../../shared/components/error/error.component";
import {NgModule} from "@angular/core";
import {PendingEventsComponent} from "./pending-events/pending-events.component";
import {AllEventsComponent} from "./all-events/all-events.component";
import {ReportsComponent} from "./reports/reports.component";
import {AuthGuardTsGuard} from "../../guard/auth-guard.ts.guard";
import {UsersComponent} from "./users/users.component";
import {UserAdminComponentTypeEnum} from "./users/user-admin-component-type.enum";
import {UserRoleEnum} from "../../shared/enums/user-role.enum";
import {RolesGuard} from "../../guard/roles-guard.ts.guard";
import {FeedbacksComponent} from "./feedbacks/feedbacks.component";
import {EventsToRemoveComponent} from "./events-to-remove/events-to-remove.component";

const routes: Routes = [

  //base routing
  {
    path: 'admin', component: AdminLayoutComponent, children: [
      {path: 'novas-ocorrencias', component: PendingEventsComponent},
      {path: 'todas-ocorrencias', component: AllEventsComponent},
      {path: 'por-remover-ocorrencias', component: EventsToRemoveComponent},
      {path: 'reclamacoes', component: ReportsComponent,},
      {path: 'feedbacks', component: FeedbacksComponent,},
      {
        path: 'privilegios',
        component: UsersComponent,
        data: {
          allowedRoutes: [UserRoleEnum.MASTER],
          componentType: UserAdminComponentTypeEnum.PRIVILEGE
        },
        canActivate: [RolesGuard],
        canActivateChild: [RolesGuard]
      },
      {path: 'utilizadores', component: UsersComponent, data: {componentType: UserAdminComponentTypeEnum.ALL}},
      {
        path: 'utilizadores-bloqueados',
        component: UsersComponent,
        data: {componentType: UserAdminComponentTypeEnum.BLOCKED}
      },
    ],
    canActivate: [AuthGuardTsGuard],
    canActivateChild: [AuthGuardTsGuard]
  },

  {path: "**", component: ErrorComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule {

}
